import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { fetchOtherService, fetchSalesOrderDetail } from '../../actions/otherService_actions';

import OtherService from '../../components/Sales/otherService';

const otherService = reduxForm({
  form: 'otherService',
  destroyOnUnmount: false,
})(OtherService);

function mapStateToProps(state) {
  return {
    currentSalesOrder: state.otherService.currentSalesOrder,
    otherService: state.otherService.all,
    isLoading: state.otherService.isLoading,
    error: state.otherService.error,
    salesOrderDetail: state.otherService.currentSalesOrderDetail,
    salesOrderIsLoading: state.otherService.detailIsLoading,
    salesOrderError: state.otherService.detailError,
    salesOrdersFilter: state.otherService.salesOrdersFilter,
    userPermissions: state.auth.userPermissions,
    users: state.settings.all,
    usersIsLoading: state.settings.isLoading,
    usersError: state.settings.error,
    msoTotalPages: state.otherService.msoTotalPages,

    requestingShippingList: state.otherService.requestingShippingList,
    shippingListPDF: state.otherService.shippingListPDF,

    requestingPickingList: state.otherService.requestingPickingList,
    pickingListPDF: state.otherService.pickingListPDF,

    requestingPackingList: state.otherService.requestingPackingList,
    packingListPDF: state.otherService.packingListPDF,

    requestingSalesOrderPDF: state.otherService.requestingSalesOrderPDF,
    salesOrderPDF: state.otherService.salesOrderPDF,

    requestingBolIdPDF: state.otherService.requestingBolIdPDF,
    bolIdPDF: state.otherService.bolIdPDF,
    requestingBolWithoutLogPDF: state.otherService.requestingBolWithoutLogPDF,
    bolWithoutLogPDF: state.otherService.bolWithoutLogPDF,
    requestingBolLabel: state.otherService.requestingBolLabel,
    bolLabel: state.otherService.bolLabel,
    requestingBolFbaPDF: state.otherService.requestingBolFbaPDF,
    bolFbaPDF: state.otherService.bolFbaPDF,
    bolAddress: state.otherService.bolAddress,
    quoteLoading: state.otherService.quoteLoading,
  };
}

export default connect(mapStateToProps, {
  fetchOtherService,
  fetchSalesOrderDetail,
})(otherService);



// WEBPACK FOOTER //
// ./master/jsx/containers/Sales/otherService.jsx